import MenuProtocoloTypes from './types'

const INITIAL_STATE = {
    tipo: '',
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
         
        case MenuProtocoloTypes.TIPO:

            let tipo =  action.payload.tipo;

            return {
                ...state,
                tipo
            };

        case MenuProtocoloTypes.TIPOSAGA:

            tipo =  action.payload.tipo;

            return {
                ...state,
                tipo
            };

        default:
            return state;
    }
}